$(function() {
    var rules = {};

    $('[name*="phone"]').each(function() {
        rules[this.name] = {
            phone: true
        }
    });

    $("[name*=\"post_code\"]").each(function() {
        rules[this.name] = {
            number: true
        }
    });

    $('.js-account-addresses').validate({
        rules: rules,
        submitHandler: function(form) {
            $(form).find('[type="submit"]')
                .prop('disabled', true)
                .addClass('is-loading');

            window.assignRecaptchaResponseToForm(form).then(function() {
                form.submit();
            });
        }
    });

    $('.js-account-addresses-modal').validate({
        rules: rules,
        submitHandler: function(form) {
            $(form).find('[type="submit"]')
                .prop('disabled', true)
                .addClass('is-loading');

            window.assignRecaptchaResponseToForm(form).then(function() {
                form.submit();
            });
        }
    });
});